import { render, staticRenderFns } from "./Dialogs_StoreShopMsg.vue?vue&type=template&id=86bf7b1a&scoped=true&"
import script from "./Dialogs_StoreShopMsg.vue?vue&type=script&lang=js&"
export * from "./Dialogs_StoreShopMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86bf7b1a",
  null
  
)

export default component.exports